/** Domain constants shared by the API and the web client. */
/**
 * Display name of the league, used in the UI and in outbound email.
 *
 * Defined once here rather than repeated: it previously appeared in ten places,
 * which is how a rename becomes a game of hunt-the-string. The one copy this
 * cannot reach is the `<title>` in `packages/web/index.html`, which is static
 * HTML — keep the two in step.
 */
export const APP_NAME = 'All OXTS Foosball League';
/**
 * Who to contact about personal data — named in the privacy notice as the
 * controller's contact address, and the route for access/erasure requests.
 *
 * EDIT THIS before the notice is of any use: a privacy notice with no working
 * contact address is worse than none, because it advertises a right nobody can
 * actually exercise.
 */
export const PRIVACY_CONTACT_EMAIL = 'oxtsfoos@gmail.com';
/**
 * The league is run privately by a colleague, not by OXTS. Stated plainly in
 * the notice and at sign-up because people will otherwise reasonably assume an
 * app on a company-flavoured domain is a company system — and that assumption
 * changes who they think holds their data and who they would complain to.
 */
export const OPERATOR_DISCLAIMER = 'This is a personal project run for the benefit of colleagues. It is not run, ' +
    'controlled, endorsed by, or affiliated with OXTS, and OXTS holds no ' +
    'responsibility for it or for the data it stores.';
export const FORMATS = ['1v1', '2v2'];
export const SIDES = ['A', 'B'];
export const POSITIONS = ['attack', 'defence'];
export const MATCH_STATUSES = ['pending', 'confirmed', 'disputed', 'void'];
export const USER_ROLES = ['player', 'admin'];
export const USER_STATUSES = ['active', 'inactive'];
/** How many players each side must field, per format. */
export const PLAYERS_PER_SIDE = {
    '1v1': 1,
    '2v2': 2,
};
// --- Elo ---------------------------------------------------------------
export const DEFAULT_RATING = 1200;
/** Ratings are stored SMALLINT UNSIGNED; these bounds keep them in range. */
export const MIN_RATING = 100;
export const MAX_RATING = 4000;
export const K_PROVISIONAL = 40;
export const K_INTERMEDIATE = 32;
export const K_ESTABLISHED = 24;
export const K_ELITE = 16;
export const PROVISIONAL_GAMES = 10;
export const INTERMEDIATE_GAMES = 30;
/** At or above this rating the K-factor drops regardless of games played. */
export const ELITE_RATING = 2100;
/** `1 + ln(1 + margin) / ln(MARGIN_LOG_BASE)`, capped. */
export const MARGIN_LOG_BASE = 11;
export const MARGIN_MULTIPLIER_CAP = 1.75;
// --- Match rules -------------------------------------------------------
/**
 * Default first-to-N target. Overridable per season via `seasons.win_score`,
 * so a league can play first-to-5 or first-to-21 without a code change.
 */
export const DEFAULT_WIN_SCORE = 10;
export const MIN_WIN_SCORE = 1;
export const MAX_WIN_SCORE = 50;
/** Upper bound on any single score, independent of the season target. */
export const MAX_SCORE = 99;
export const DEFAULT_POINTS_WIN = 3;
export const DEFAULT_POINTS_LOSS = 0;
/** Hours a pending result waits before the auto-confirm job accepts it. */
export const DEFAULT_AUTO_CONFIRM_HOURS = 24;
// --- Auth --------------------------------------------------------------
export const ACCESS_TOKEN_TTL_SECONDS = 15 * 60;
export const REFRESH_TOKEN_TTL_DAYS = 30;
export const MIN_PASSWORD_LENGTH = 10;
export const MAX_PASSWORD_LENGTH = 200;
export const MAX_DISPLAY_NAME_LENGTH = 60;
export const MAX_NOTES_LENGTH = 280;
//# sourceMappingURL=constants.js.map